
export default {
    data() {
        return {
            form: {
                id: '',
                nama_komponen: '',
            },
            list_data: [],
            cari_value: "",
            mdl_add: false,
            mdl_edit: false,
            mdl_hapus: false,
            btn_add: false,
            btn_edit: false,
            btn_hapus: false,
        }
    },
    methods: {
        getView: function () {
            this.$store.commit("shoWLoading");
            fetch(this.$store.state.url.KOMPONEN + "view", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    cari_value: this.cari_value,
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_data = res_data.data;
                    this.$store.commit("hideLoading");
                    console.log(res_data);
                });
        },
        addData: function () {
            this.btn_add = true;
            fetch(this.$store.state.url.KOMPONEN + "addData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.form)
            }).then(res_data => {
                this.btn_add = false;
                this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
                this.getView();
                this.mdl_add = false;
                this.resetForm();
            });
        },
        editData: function () {
            this.btn_edit = true;
            fetch(this.$store.state.url.KOMPONEN + "editData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.form)
            }).then(res_data => {
                this.btn_edit = false;
                this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
                this.getView();
                this.mdl_edit = false;
                this.resetForm();
            });
        },
        removeData: function () {
            this.btn_hapus = true;
            fetch(this.$store.state.url.KOMPONEN + "removeData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({ id: this.form.id })
            }).then(res_data => {
                this.btn_hapus = false;
                this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
                this.getView();
                this.mdl_hapus = false;
                this.resetForm();
            });
        },
        selectData: function (data) {
            this.form.id = data.id;
            this.form.nama_komponen = data.nama_komponen;
        },
        resetForm: function () {
            this.form.id = '';
            this.form.nama_komponen = '';
        },
        Notify: function (message, positive, icon) {
            this.$q.notify({
                message: message,
                color: positive,
                icon: icon,
                position: 'top',
                timeout: 500,
            })
        },
        cari_data: function () {
            this.getView();
        },
    },
    mounted() {
        this.getView();
    },
}
